if (!window.productShowcaseGridBound) {
  window.productShowcaseGridBound = true;

  const updateShowcaseVariantImage = (event) => {
    const form = event.detail?.form;
    const variant = event.detail?.variant;
    if (!form || !variant) return;

    const card = form.closest('.product-showcase-card');
    if (!card?.closest('.product-showcase-grid')) return;

    const dataEl = card.querySelector('[data-showcase-variant-images]');
    const imageEl = card.querySelector('[data-variant-image] .theme-img');
    if (!dataEl || !imageEl) return;

    let images;
    try {
      images = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    const imageData = images[String(variant.id)];
    if (!imageData?.src) return;

    imageEl.src = imageData.src;
    if (imageData.srcset) {
      imageEl.srcset = imageData.srcset;
    } else {
      imageEl.removeAttribute('srcset');
    }
    if (imageData.width) imageEl.width = imageData.width;
    if (imageData.height) imageEl.height = imageData.height;
  };

  document.addEventListener('on:variant:change', updateShowcaseVariantImage);
}
